export default __webpack_public_path__ + "static/media/bnb-bnb-logo.797868eb.svg";